import Rest from "../../../class/tool/Rest";
import FormBuilder from "../../../class/tool/FormBuilder";
import AutomaticDrawer from "./AutomaticDrawer";
import DrawerEventEntryController from "../../_legaldata/DrawerEventEntries/DrawerEventEntryController";

class AutomaticDrawerController {
    #_rest = new Rest();
    _callback = null;
    _baseURL = "automaticdrawers";
    static _drawers = [
        {
            brand: "GLORY",
            model: "CI-5",
            interfaceTypes: "ip"
        },
        {
            brand: "GLORY",
            model: "CI-10",
            interfaceTypes: "ip"
        },
        {
            brand: "GLORY",
            model: "CI-10X",
            interfaceTypes: "ip"
        }
    ];
    static _denominations = [
        { fv: "1", value: .01, euro: "0,01", devid: "2" },
        { fv: "2", value: .02, euro: "0,02", devid: "2" },
        { fv: "5", value: .05, euro: "0,05", devid: "2" },
        { fv: "10", value: .1, euro: "0,10", devid: "2" },
        { fv: "20", value: .2, euro: "0,20", devid: "2" },
        { fv: "50", value: .5, euro: "0,50", devid: "2" },
        { fv: "100", value: 1, euro: "1", devid: "2" },
        { fv: "200", value: 2, euro: "2", devid: "2" },
        { fv: "500", value: 5, euro: "5", devid: "1" },
        { fv: "1000", value: 10, euro: "10", devid: "1" },
        { fv: "2000", value: 20, euro: "20", devid: "1" },
        { fv: "5000", value: 50, euro: "50", devid: "1" },
        { fv: "10000", value: 100, euro: "100", devid: "1" },
        { fv: "20000", value: 200, euro: "200", devid: "1" },
        { fv: "50000", value: 500, euro: "500", devid: "1" }
    ];
    static _inventoryStates = {
        0: "EMPTY",
        1: "LOW",
        2: "EXIST",
        3: "HIGH",
        4: "FULL"
    };

    static checkName(val) {
        //const regxp = /^[\w&-_. ]{2,50}$/g;

        if(val === "") throw new Error("EMPTY");
        //if (!regxp.test(val.removeDiacritics())) throw new Error("WRONG");

        return true;
    }
    static checkReference(val) {
        const regxp = /^[a-zA-Z0-9-_+#\/\\]{2,}$/g;

        if (val !== "" && !regxp.test(val.removeDiacritics())) throw new Error("WRONG");

        return true;
    }
    static checkActive(val) {
        const regxp = /^0|1$/g;

        if(val === "") throw new Error("EMPTY");
        if (!regxp.test(val)) throw new Error("WRONG");

        return true;
    }
    static checkBrand(val) {
        //const regxp = /^[\w&-_. ]{2,50}$/g;

        if(val === "") throw new Error("EMPTY");
        //if (!regxp.test(val.removeDiacritics())) throw new Error("WRONG");

        return true;
    }
    static checkModel(val) {
        //const regxp = /^[\w&-_. ]{2,50}$/g;

        if(val === "") throw new Error("EMPTY");
        //if (!regxp.test(val.removeDiacritics())) throw new Error("WRONG");

        return true;
    }
    static checkIpAddress(val) {
        const regxp = /^(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}$/gm;

        if(val === "") throw new Error("EMPTY");
        if (!regxp.test(val.removeDiacritics())) throw new Error("WRONG");

        return true;
    }
    static checkLicenses(val) {
        if (val.length < 1) throw new Error("EMPTY");

        return true;
    }

    setFormValues(object, setValues, start = false) {
        let licenses = []

        for (let i = 0; i < object.licenses.length; i++)
            licenses.push(object.licenses[i].license_id)

        setValues(prev => ({
            ...prev,
            name: object.name,
            reference: object.reference,
            brand: object.brand,
            model: object.model,
            ipAddress: object.ipAddress,
            active: start ? 1 : object.active,
            allowsDisconnectedAutomaticDrawer: start ? 0 : object.allowsDisconnectedAutomaticDrawer,
            allowsSimultaneousOperation: start ? 1 : object.allowsSimultaneousOperation,
            licenses: licenses,
            usable500: start ? 0 : object.usable500,
            usable200: start ? 0 : object.usable200,
            usable100: start ? 0 : object.usable100,
            usable50: start ? 1 : object.usable50
        }));
    }
    returnUpdatesFromCompare(object, datas, compare = true) {
        let obj = Object.assign({}, object)
        let licenses = object.licenses
        obj.licenses = []

        for (let i in licenses) {
            obj.licenses.push(licenses[i].license_id)
        }

        return FormBuilder.returnUpdates(obj, datas, compare)
    }
    completeDatasToUpdate(object, datas) {
        let datasToUpdate = Object.assign({}, datas)
        const ipRow = ["ipAddress"]

        for (let i in ipRow)
            if (datasToUpdate[ipRow[i]] === undefined)
                datasToUpdate[ipRow[i]] = object[ipRow[i]]

        return datasToUpdate
    }
    checkValues(object) {
        const params = [
            { name: "name", method: "checkName", val: object.name },
            { name: "label", method: "checkLabel", val: object.label },
            { name: "reference", method: "checkReference", val: object.reference },
            { name: "referenceProvider", method: "checkReferenceProvider", val: object.referenceProvider },
            { name: "provider", method: "checkProvider", val: object.provider_id },
            { name: "brand", method: "checkBrand", val: object.brand_id },
            { name: "category", method: "checkCategory", val: { id: object.category_id, type: object.category_type } },
            { name: "description", method: "checkDescription", val: object.description },
            { name: "nullStockTrigger", method: "checkNullStockTrigger", val: object.nullStockTrigger },
            { name: "printDescription", method: "checkPrintDescription", val: object.printDescription },
            { name: "soldOut", method: "checkSoldOut", val: object.soldOut },
            { name: "stockManagement", method: "checkStockManagement", val: object.stockManagement },
            { name: "stockThresholdTrigger", method: "checkStockThresholdTrigger", val: object.stockThresholdTrigger },
            { name: "unit", method: "checkUnit", val: object.unit },
            { name: "variablePrice", method: "checkVariablePrice", val: object.variablePrice }
        ];
        let errors = {};
        let method;

        for (let i in params) {
            method = AutomaticDrawerController[params[i].method];

            try { method.apply(null, params[i].val); }
            catch (e) { errors.params[i].name = e.message; }
        }

        if (Object.keys(errors).length > 0) throw new Error(JSON.stringify(errors));
        else return true;
    }

    index(filters = null, page = 1, nb = 25, sortingName = "", sortingValue = "", tree = false) {
        let params = "";

        if (filters !== undefined && filters !== null) {
            if (filters.license_id !== undefined && filters.license_id !== null)
                params += (params.length === 0 ? "?" : "&") + "license_id=" + filters.license_id;

            if (filters.input !== undefined && filters.input !== null)
                params += (params.length === 0 ? "?" : "&") + "input=" + filters.input;

            if (filters.inputs !== undefined && filters.inputs !== null && filters.inputs.length > 0) {
                for (let i in filters.inputs) {
                    let input = filters.inputs[i];

                    switch (input.attribute) {
                        case "name":
                            params += (params.length === 0 ? "?" : "&") + "name=" + input.value.toString();

                            if (input.constraint !== "contains")
                                params += (params.length === 0 ? "?" : "&") + "namePosition=" + input.constraint;

                            break;
                        default: break;
                    }
                }
            }
        }

        if (page > 0) params += (params.length === 0 ? "?" : "&") + "page=" + page + "&nb=" + nb;
        if (sortingName.length > 0) params += (params.length === 0 ? "?" : "&") + "sorton=" + sortingName + "&sortvalue=" + sortingValue;
        if (tree) params += (params.length === 0 ? "?" : "&") + "tree=";

        this.#_rest.sendQuery(
            'GET',
            '/' + this._baseURL + params,
            {},
            this.handleIndex);
    }
    handleIndex = (response, error, status = 200) => {
        let listObjects = [];
        let pagination = null;

        if(status === 200) {
            let data;

            if (response.data !== undefined && response.data.data !== undefined) {
                if(response.data.total !== undefined) {
                    pagination = {
                        total: response.data.total,
                        from: response.data.from != null ? response.data.from : 0,
                        to: response.data.to != null ? response.data.to : 0,
                        per_page: response.data.per_page,
                        current_page: response.data.current_page,
                        first_page_url: new URL(response.data.first_page_url).search,
                        last_page_url: new URL(response.data.last_page_url).search,
                        next_page_url: response.data.next_page_url !== null ? new URL(response.data.next_page_url).search : null,
                        prev_page_url: response.data.prev_page_url !== null ? new URL(response.data.prev_page_url).search : null
                    }
                }

                data = response.data.data;
            }
            else if (response.data)
                data = response.data;

            for(let item in data)
                listObjects.push(new AutomaticDrawer(data[item]));
        }

        this._callback(listObjects, error, pagination, status)
    }

    show(id) {
        this.#_rest.sendQuery(
            'GET',
            '/' + this._baseURL + '/' + id,
            {},
            this.handleShow);
    }
    handleShow = (response, error, status = 200) => {
        const object = !error ? new AutomaticDrawer(response.data) : null;
        this._callback(object, error, status);
    }

    post(datas) {
        this.#_rest.sendQuery(
            'POST',
            '/' + this._baseURL,
            datas,
            this.handlePost);
    }
    handlePost = (response, error, status) => {
        this._callback(response, error, status);
    }

    put(object, datas) {
        this.#_rest.sendQuery(
            'PUT',
            '/' + this._baseURL + '/' + object.id,
            datas,
            this.handlePut);
    }
    handlePut = (response, error, status) => {
        this._callback(response, error, status);
    }

    delete(object) {
        this.#_rest.sendQuery(
            'DELETE',
            '/' + this._baseURL + '/' + object.id,
            {},
            this.handleDelete);
    }
    handleDelete = (response, error, status) => {
        this._callback(response, error, status);
    }

    histo() {
        this.#_rest.sendQuery(
            'GET',
            '/' + this._baseURL + '/histos',
            {},
            this.handleHisto);
    }
    handleHisto = (response, error, status = 200) => {
        let listObjects = [];

        if(status === 200) {
            let data = response.data;

            for(var item in data)
                listObjects.push(data[item]);
        }

        this._callback(listObjects, error, status);
    }

    histoTarget(id) {
        this.#_rest.sendQuery(
            'GET',
            '/' + this._baseURL + '/' + id + '/histos',
            {},
            this.handleHistoTarget);
    }
    handleHistoTarget = (response, error, status = 200) => {
        let listObjects = [];

        if(status === 200) {
            let data = response.data;

            for(var item in data)
                listObjects.push(data[item]);
        }

        this._callback(listObjects, error, status);
    }
}

export default AutomaticDrawerController;
